/*
*@desc page bus
*
*/

var listeners = {};
var bus = {
  $on: function $on(event, callback) {
    (listeners[event] || (listeners[event] = [])).push(callback);
  },
  $off: function $off(event, callback) {
    if (!listeners[event]) return;
    listeners[event] = listeners[event].filter(function (cb) {
      return cb !== callback;
    });
  },
  $emit: function $emit(event, payload) {
    (listeners[event] || []).forEach(function (cb) {
      return cb(payload);
    });
  }
};
export default bus;